import React, { forwardRef, MouseEvent } from 'react';
import styled from '@emotion/styled';
import {
	IPaperSelectorProps,
	PaperSelector,
	useCustomEventHandler,
} from '../../../../../ui';
import { ITokenizedCard } from '../../../domain/models';
import { CreditCardLogo } from '../logo/CreditCardLogo';
import { TokenizedCardDetails } from './TokenizedCardDetails';
import { DeleteCardButton, StyledDeleteCardButton } from './DeleteCardButton';

interface ITokenizedCardSelectorProps
	extends Omit<IPaperSelectorProps, 'name' | 'type' | 'value'> {
	card: ITokenizedCard;
	canBeDeleted?: boolean;
	onClickDelete?: (e: MouseEvent<HTMLDivElement>) => void;
}

export const TokenizedCardSelector = forwardRef<
	HTMLInputElement,
	ITokenizedCardSelectorProps
>(({ card, onClickDelete, ...rest }: ITokenizedCardSelectorProps, ref) => {
	const handleClickDelete = useCustomEventHandler((e: MouseEvent) => {
		e.preventDefault();
	}, onClickDelete);

	return (
		<StyledTokenizedCardSelector
			ref={ref}
			type="radio"
			name="tokenizedCardId"
			value={card.id}
			{...rest}
		>
			<CreditCardLogo type={card.creditCardType} />
			<TokenizedCardDetails card={card} />
			<DeleteCardButton onClick={handleClickDelete} />
		</StyledTokenizedCardSelector>
	);
});

const StyledTokenizedCardSelector = styled(PaperSelector)`
	display: flex;
	align-items: flex-start;

	@media (hover: hover) {
		${StyledDeleteCardButton} {
			visibility: hidden;
		}

		&:hover {
			${StyledDeleteCardButton} {
				visibility: visible;
			}
		}
	}
`;
